/* eslint-disable new-cap */

import {
  OPEN_CHILDCARE_INFORMATIONS_MODAL,
  CLOSE_CHILDCARE_INFORMATIONS_MODAL,
} from 'Store/member-space/booking/booking.constants';

import createReducer from 'Store/utils/createReducer';

const initialState = {
  data: {
    isVisible: false,
    activity: null,
  },
};

export default createReducer(initialState, {
  [OPEN_CHILDCARE_INFORMATIONS_MODAL](state, { payload }) {
    return {
      ...state,
      data: {
        ...state.data,
        isVisible: true,
        activity: payload.activity,
      },
    };
  },
  [CLOSE_CHILDCARE_INFORMATIONS_MODAL]() {
    return initialState;
  },
});
